import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    loadCredentialingSpecialistsFailure,
    loadCredentialingSpecialistsFromFacilityContracts,
    loadCredentialingSpecialistsFromPrestartGrid,
    loadCredentialingSpecialistsFromReassignDialog,
    loadCredentialingSpecialistsSuccessfully
} from 'src/app/compliance/store/actions/compliance.actions';
import { ContractAssignmentService } from 'src/app/shared/services/contract-assignments.service';
import { loadCredentialingSpecialistsFromCSEdit } from '../actions/compliance.actions';

@Injectable()
export class CredentialingSpecialistsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _contractAssignmentService: ContractAssignmentService
    ) {}

    getCredentialingSpecialists$ = createEffect(() =>
        this._actions$.pipe(
            ofType(
                loadCredentialingSpecialistsFromPrestartGrid,
                loadCredentialingSpecialistsFromReassignDialog,
                loadCredentialingSpecialistsFromCSEdit,
                loadCredentialingSpecialistsFromFacilityContracts
            ),
            switchMap(() => {
                return this._contractAssignmentService.getCredentialingSpecialists().pipe(
                    map((specialists) =>
                        loadCredentialingSpecialistsSuccessfully({ credentialingSpecialists: specialists })
                    ),
                    catchError((error: unknown) => of(loadCredentialingSpecialistsFailure({ error })))
                );
            })
        )
    );
}
